import React, { useContext } from 'react'
import { useSelector } from 'react-redux';
import { ThemeContext } from '../contexts/ThemeContext';
import { useTranslation } from 'react-i18next';

function Categories() {

    const { categories } = useSelector((state) => state.categories);
    const { theme } = useContext(ThemeContext);
    const { t } = useTranslation("home");
    
    

  return (
    <section className='popular_categories'>
    <h2 className="page_title">All Categories</h2>

    {/* <div className="section_title">{t('popular_categories')}</div> */}
    <div className="row">
        {categories.map((cate) => (
        <div key={cate.id} className="col-2">
            <div className="cate mx-1">
                <div className="cate_img"><img
                        src={cate.image}
                        alt={cate.name_ar} /></div>
                <p className='cate_name'>{cate.name_ar}</p>
            </div>
        </div>
        ))}
    </div>
</section>

  )
}

export default Categories